<template>
    <div class="flex justify-between xl:justify-center xl:px-0 mb-6 space-x-2 items-center">
        <PricingCurrencySelect v-if="useDevice().isDesktop && (userData.free_plan || !auth)" v-model="currencyValue" />
        <div
            class="place-self-center h-14 w-[255px] flex justify-center items-center px-2 lg:space-x-4 space-x-2 transition-all rounded-full bg-gray-900 border border-gray-850"
            :class="userData.free_plan ? '' : 'mx-auto'"
        >
            <template v-for="(tabItem, tabIndex) in pricingTabItems">
                <button
                    class="p-2 xl:w-fit w-full rounded-full transition-all font-medium text-body-sm px-4 py-2 h-9 flex space-x-1 items-center"
                    :class="[
                        activeCycle === tabItem.key ? 'bg-[#4D4DBD66] text-brand-100  ' : 'text-gray-400',
                        tabIndex == 1 ? 'lg:!w-[168px]  ' : '!w-[168px] lg:!w-fit',
                    ]"
                    @click="changeActiveTab(tabItem.key)"
                >
                    <div class="w-full">
                        <span class=""> {{ tabItem.title }}</span>
                        <span
                            class="text-orange-400 whitespace-nowrap"
                            v-if="tabItem.title === t('pages_pricing_business')"
                            >{{ tabItem.discount }}</span
                        >
                    </div>
                </button>
            </template>
        </div>
        <PricingCurrencySelect v-if="!useDevice().isDesktop && (userData.free_plan || !auth)" v-model="currencyValue" />
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
const auth = useAuth();
const { userData } = storeToRefs(useUserStore());
const { activeCycle, currentCurrency, pricingCardsDataMonthly, pricingCardsDataYearly } = storeToRefs(
    usePricingStore()
);
const currencyValue = ref(currentCurrency.value);

const { t } = useI18n();
const pricingTabItems: { title: string; key: "yearly" | "monthly"; discount?: string }[] = [
    {
        title: t("pages_pricing_individual"),
        key: "monthly",
    },
    {
        title: t("pages_pricing_business"),
        key: "yearly",
        discount: t("pages_pricing_offText"),
    },
];

const changeActiveTab = (cycle: "yearly" | "monthly") => {
    activeCycle.value = cycle;
};

watch(activeCycle, async () => {
    //Check For Cached data
    if (activeCycle.value === "yearly" && pricingCardsDataYearly.value.length > 0) return;
    if (activeCycle.value === "monthly" && pricingCardsDataMonthly.value.length > 0) return;
    await usePricingStore().fetchPricingPlansData();
});

watch(currencyValue, async () => {
    currentCurrency.value = currencyValue.value;

    //Delete the cached data
    pricingCardsDataMonthly.value = [];
    pricingCardsDataYearly.value = [];
    await usePricingStore().fetchPricingPlansData();
});
</script>
